<ul class="social-sharebox nav nav-pills list-no-default-spacing">
  @for (item of items; track item.name) {
    <li class="nav-item me-1">
      <a
        [href]="item.url"
        [title]="item.name"
        class="social-sharebox__link"
        [ngClass]="'social-sharebox__link--' + item.cssName"
        (click)="openShare(item.url)"
        target="_blank"
      >
        <fa-icon
          class="icon d-flex position-relative fa-2x"
          [ngClass]="'icon--' + item.cssName"
          [icon]="item.icon | scIcon"
        ></fa-icon>
        <span class="sr-only">{{ item.name }}</span>
      </a>
    </li>
  }
</ul>
